import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const profilePictureApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProfilePicture: builder.query({
      query: ({ providerFhirId }: { providerFhirId: string }) => {
         const headers = getHeadersFromRedux();
        return {
          url: `/api/v1/Provider/${providerFhirId}/profile-photo`,
          method: "GET",
          headers
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetProfilePictureQuery } = profilePictureApi;
export default profilePictureApi;
